"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestService = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const page_1 = require("../page/page");
const index_1 = require("./index");
const batch_observable_1 = require("./util/batch.observable");
class ObservableFetchableStore {
    setIsFetching(isFetching) {
        this.isFetching = isFetching;
    }
    setValue(value, lastFetch) {
        this.value = value;
        this.lastFetch = lastFetch;
        this.isFetching = false;
    }
    setError(error) {
        this.error = error;
        this.isFetching = false;
    }
}
tslib_1.__decorate([
    batch_observable_1.batchObservable
], ObservableFetchableStore.prototype, "value", void 0);
tslib_1.__decorate([
    batch_observable_1.batchObservable
], ObservableFetchableStore.prototype, "error", void 0);
tslib_1.__decorate([
    batch_observable_1.batchObservable
], ObservableFetchableStore.prototype, "isFetching", void 0);
tslib_1.__decorate([
    batch_observable_1.batchObservable
], ObservableFetchableStore.prototype, "lastFetch", void 0);
tslib_1.__decorate([
    mobx_1.action
], ObservableFetchableStore.prototype, "setIsFetching", null);
tslib_1.__decorate([
    mobx_1.action
], ObservableFetchableStore.prototype, "setValue", null);
tslib_1.__decorate([
    mobx_1.action
], ObservableFetchableStore.prototype, "setError", null);
class IkeRestService {
    constructor() {
        this.__priority = 10; // After config and log service
    }
    init() {
        core_shared_1.IkeRest.FetchableStore = ObservableFetchableStore;
        const config = index_1.Services.Config.config;
        this.rest = core_shared_1.IkeRest.create(config, {
            log: index_1.Services.Log.Logger
        });
        this.rest.onError(core_shared_1.IkeRequestErrorType.INVALID_SESSION, this.reauthenticateUser);
        this.rest.onError(core_shared_1.IkeRequestErrorType.LICENSE_REQUIRED, this.handleNoLicenseResponse);
    }
    reauthenticateUser() {
        index_1.Services.Route.go(page_1.IkePageName.logout);
    }
    handleNoLicenseResponse() {
        index_1.Services.License.hasNoLicense = true;
    }
}
exports.IkeRestService = IkeRestService;
//# sourceMappingURL=ike.rest.service.js.map